import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let patient_id = useDataValue({
    context: 'selected',
    path: 'patient_id',
    viewPath: props.viewPath,
  })

  return {
    variables: {
      id: patient_id,
    },
    pause: !patient_id,
  }
}
